import React from 'react';
import PropTypes from 'prop-types';
import {FaSave as IconSave} from 'react-icons/fa';
import { List, Map } from 'immutable';
import ToolbarButton from './toolbar-button';
import {browserDownload}  from '../../utils/browser';
import { Project } from '../../class/export';
import { ApiUtils } from '../../utils/export';

/* AlgoJson is defined to be used for AI design algorithm in the backend
source format:
{
  "aiDesignParams": {
    "lengthUnit": "cm",
    "budget": null,
    "budgetUnit": "JPY",
    "kitchenLayout": "L-shaped",
    "roomCounts": {
      "livingRoom": 1,
      "kitchen": 1,
      "garage": 0,
      "bathroom": 1,
      "tatamiRoom": 0,
      "entry": 0,
      "diningRoom": 1,
      "workspace": 0,
      "mudroom": 0,
      "bedroom": 1,
      "laundry": 0
    },
    "roomRelationships": {
      "bubbles": [
        {
          "id": 1,
          "roomName": "livingRoom_1",
          "x": 150,
          "y": 150,
          "size": 70,
          "color": "#e74c3c",
          "displayName": "LivingRoom 1"
        }
      ],
      "connections": [
        {
          "source": "diningRoom_1",
          "target": "bathroom_1"
        }
      ]
    }
  },
  "scene": {}
}

target format:
{
  "Room": {
    "num": 1,
    "rooms": [
      {
        "name": "Room_1",
        "link": [
          "Bathroom1",
          "Bedroom1",
          "Kitchen1",
          "DiningRoom1",
          "LivingRoom1"
        ],
        "location": "northeast",
        "size": "S"
      }
    ]
  }
}
*/

export default function ToolbarSaveButton({state}, {translator}) {

  let saveProjectToFile = e => {
    e.preventDefault();
    state = Project.unselectAll( state ).updatedState;
    const exportedJson = {
      "aiDesignParamsAlgoJson": ApiUtils.convertAIParamsToAlgoJson(state.get('aiDesignParams')),
      "scene": state.get('scene').toJS()
    }
    browserDownload(exportedJson);
  };

  return (
    <ToolbarButton active={false} tooltip={translator.t('Save project')} onClick={saveProjectToFile}>
      <IconSave />
    </ToolbarButton>
  );
}

ToolbarSaveButton.propTypes = {
  state: PropTypes.object.isRequired,
};

ToolbarSaveButton.contextTypes = {
  translator: PropTypes.object.isRequired,
};
